import { UIStore } from "../../../stores/uiStore";

const HomeAppView = () =>
  import(/*webpackChunkName: "HomeAppView"*/ "../../../views/app/HomeApp.vue");

const HOME_ROUTE_NAMES = new Set(["home", "home-app"]);

export default {
  path: "upsale",
  name: "upsale",
  component: HomeAppView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
    isAmbiguous: true,
  },
  beforeEnter(to: any, from: any, next: any) {
    UIStore().setShowUnlockMoreBenefitsDialog(true);

    if (HOME_ROUTE_NAMES.has(String(from.name))) {
      next(false);
      return;
    }

    next({ name: "home", params: { locale: to.params.locale } });
  },
};
